import { apiFetch } from './client'

export type ReleaseState = 'released' | 'active' | 'closing' | 'planned'
export type FeatureStatus = 'plan' | 'wip' | 'done'
export type SprintState = 'closed' | 'active' | 'planned'
export type RoadmapTaskState = ' ' | '~' | 'x' | '!'

export interface ReleaseFeatureDto {
  id: string
  name: string
  desc: string
  status: FeatureStatus
  section: string | null
  sprints: string[]
}

export interface ReleaseSprintDto {
  id: string
  state: SprintState
  goal: string
  done: number
  total: number
  tasks: Array<{
    st: RoadmapTaskState
    text: string
    note?: string
  }>
}

export interface ReleaseDto {
  v: string
  state: ReleaseState
  promise: string
  date: string
  functions: ReleaseFeatureDto[]
  sprints: ReleaseSprintDto[]
  ahead?: {
    commits: number
    projects: number
  }
}

export function fetchReleases(): Promise<ReleaseDto[]> {
  return apiFetch<ReleaseDto[]>('/api/releases')
}
